import React, { useEffect } from 'react';

interface Props {
  onClose: () => void;
  onViewEstimates: () => void;
}

const EstimatesUpdateNotification: React.FC<Props> = ({ onClose, onViewEstimates }) => {
  useEffect(() => {
    const audio = new Audio('/sound/alerta.mp3');
    audio.loop = true;
    audio.play().catch(err => console.error('Error playing estimates alert sound:', err));

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'Enter') onViewEstimates();
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      audio.pause();
      audio.currentTime = 0;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <style>{`
        @keyframes est-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(243,156,18,0.6), 0 0 40px rgba(243,156,18,0.2); }
          50% { box-shadow: 0 0 0 24px rgba(243,156,18,0), 0 0 80px rgba(243,156,18,0.45); }
        }
        @keyframes est-bounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-8px) scale(1.12); }
        }
        .est-notification-card { animation: est-pulse 1.6s ease-in-out infinite; }
        .est-notification-icon { animation: est-bounce 1.2s ease-in-out infinite; display: inline-block; }
        .est-btn-primary:hover { background: #e67e22 !important; }
        .est-btn-secondary:hover { border-color: #888 !important; color: #fff !important; }
      `}</style>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.82)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="est-notification-card"
          style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)',
            border: '3px solid #f39c12',
            borderRadius: '20px',
            padding: '48px 56px',
            textAlign: 'center',
            color: '#fff',
            maxWidth: '500px',
            width: '90%',
          }}
        >
          <div className="est-notification-icon" style={{ fontSize: '72px', marginBottom: '16px' }}>
            📊
          </div>
          <h2
            style={{
              color: '#f39c12',
              marginBottom: '10px',
              fontSize: '26px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Estimaciones Actualizadas
          </h2>
          <p style={{ color: '#ccc', marginBottom: '28px', fontSize: '15px', lineHeight: '1.7' }}>
            El estimador de producción tiene <strong style={{ color: '#fff' }}>nuevos datos</strong>.<br />
            Revisa las cantidades recomendadas para el próximo bloque.
          </p>
          <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              className="est-btn-primary"
              onClick={onViewEstimates}
              style={{
                background: '#f39c12',
                color: '#000',
                border: 'none',
                padding: '14px 30px',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
                letterSpacing: '0.5px',
                transition: 'background 0.2s',
              }}
            >
              VER ESTIMACIONES
            </button>
            <button
              className="est-btn-secondary"
              onClick={onClose}
              style={{
                background: 'transparent',
                color: '#bbb',
                border: '2px solid #555',
                padding: '14px 22px',
                borderRadius: '10px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'border-color 0.2s, color 0.2s',
              }}
            >
              CERRAR
            </button>
          </div>
          <p style={{ color: '#aaa', marginTop: '16px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <kbd style={{ background: '#2a2a4a', color: '#fff', border: '1px solid #666', borderBottom: '3px solid #444', borderRadius: '5px', padding: '2px 8px', fontFamily: 'monospace', fontSize: '12px' }}>Enter</kbd>
            <span>para ver</span>
            <span style={{ color: '#555' }}>·</span>
            <kbd style={{ background: '#2a2a4a', color: '#fff', border: '1px solid #666', borderBottom: '3px solid #444', borderRadius: '5px', padding: '2px 8px', fontFamily: 'monospace', fontSize: '12px' }}>Esc</kbd>
            <span>para cerrar</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default EstimatesUpdateNotification;
